
import React, { useState,useEffect } from 'react'; // Ensure useState is imported
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { FaLock, FaUser, FaEye, FaEyeSlash } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from 'axios'

const LoginPage = () => {
  const navigate = useNavigate();
  const [error, setError] = useState('');
 
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isFormValid, setIsFormValid] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [resetMessage, setResetMessage] = useState('');
  const [isResetFormValid, setIsResetFormValid] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [username, setUsername] = useState('');
  const [userNo, setUserNo] = useState('');
  const [loginForm, setLoginForm] = useState({ logs: null });

  // Get IP/device info for login logs (optional - does not block login)
  useEffect(() => {
    const ipUrl = process.env.REACT_APP_IP_API_URL || 'https://ipapi.co/json';
    axios.get(ipUrl)
      .then((res) => {
        setLoginForm(prev => ({ ...prev, logs: res.data }));
      })
      .catch((err) => {
        if (err.response?.status === 429) {
          console.log('IP API rate limited (429) - continuing with login');
        } else {
          console.log('IP API failed:', err.message, '- continuing with login');
        }
        setLoginForm(prev => ({ ...prev, logs: '' }));
      });
  }, []);

  useEffect(() => {
    const storedUsername = localStorage.getItem('UserNo'); // Retrieve from LocalStorage
    if (storedUsername) {
      setUsername(storedUsername);
    }
  }, []);
  console.log("USErnameNo",username)

  useEffect(() => {
    const fetchUserNo = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/userLoginUserNo/${username}`);
        const data = await response.json();

        if (data.success) {
          setUserNo(data.userNo);
        } else {
          console.error('User not found');
        }
      } catch (error) {
        console.error('Error fetching userNo:', error);
      }
    };

    if (username) {
      fetchUserNo();
    }
  }, [username]);
  
  const validateForm = () => {
    const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const isPasswordValid = password.length >= 6;
    setIsFormValid(isEmailValid && isPasswordValid);
  };

  const validateResetForm = () => {
    const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const isNewPasswordValid = newPassword.length >= 6;
    setIsResetFormValid(isEmailValid && isNewPasswordValid);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/login`,
        { userNo, password, logs: loginForm.logs }
      );

      if (response.status === 200) {
        if (response.data.token) {
          localStorage.setItem('token', response.data.token);
          axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
        }
        localStorage.setItem('user', JSON.stringify(response.data.user));
        localStorage.setItem('wallet', JSON.stringify(response.data.wallet || {}));
        localStorage.setItem('history', JSON.stringify(response.data.history || []));

        if (response.data.isFirstLogin) {
          navigate('/change-password');
        } else {
          navigate('/');
          window.location.reload();
        }
      } else {
        setError(response.data?.message || 'Login failed. Please try again.');
      }
    } catch (error) {
      setError(error.response?.data?.message || 'Login failed. Please try again.');
      console.log(error);
    }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, newPassword }),
      });

      const data = await response.json();
      if (response.ok) {
        setResetMessage('Password reset successful! You can now log in with the new password.');
        setShowForgotPassword(false);
        setNewPassword('');
      } else {
        setResetMessage(data.message || 'Password reset failed. Try again.');
      }
    } catch (error) {
      setResetMessage('Error connecting to server. Try again later.');
    }
  };

  return (
    <LoginPageContainer>
      <LoginFormWrapper>
        <LoginFormContainer>
          <Logo>
            <BrandHeading>
              <BrandMain>YOX</BrandMain>
              <BrandAccent>9</BrandAccent>
            </BrandHeading>
          </Logo>

          {!showForgotPassword ? (
            <>
              <FormTitle>Sign in</FormTitle>
              {error && <ErrorMessage>{error}</ErrorMessage>}
              <form onSubmit={handleSubmit}>
                <FormGroup>
                  <InputGroup>
                    <IconWrapper>
                      C
                    </IconWrapper>
                    <Input
                      type="text"
                      placeholder="Client Code*"
                      value={userNo}
                      onChange={(e) => setUserNo(e.target.value)}
                      required
                    />
                  </InputGroup>
                </FormGroup>

                <FormGroup>
                  <InputGroup>
                    <IconWrapper>
                      <FaLock />
                    </IconWrapper>
                    <Input
                      type={showPassword ? "text" : "password"}
                      placeholder="Password*"
                      value={password}
                      onChange={(e) => {
                        setPassword(e.target.value);
                      }}
                      required
                    />
                    <PasswordToggle onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </PasswordToggle>
                  </InputGroup>
                </FormGroup>

                <RememberRow>
                  <RememberCheckbox type="checkbox" id="rememberMe" />
                  <RememberLabel htmlFor="rememberMe">Remember me</RememberLabel>
                </RememberRow>

                <Button type="submit">
                  SIGN IN
                </Button>
              </form>
            </>
          ) : (
            <>
              <FormTitle>Reset Password</FormTitle>
              {resetMessage && <SuccessMessage>{resetMessage}</SuccessMessage>}
              <form onSubmit={handleForgotPassword}>
                <FormGroup>
                  <InputGroup>
                    <IconWrapper>
                      <FaUser />
                    </IconWrapper>
                    <Input
                      type="email"
                      placeholder="Your Email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        validateResetForm();
                      }}
                      required
                    />
                  </InputGroup>
                </FormGroup>

                <FormGroup>
                  <InputGroup>
                    <IconWrapper>
                      <FaLock />
                    </IconWrapper>
                    <Input
                      type={showNewPassword ? "text" : "password"}
                      placeholder="New Password"
                      value={newPassword}
                      onChange={(e) => {
                        setNewPassword(e.target.value);
                        validateResetForm();
                      }}
                      required
                    />
                    <PasswordToggle onClick={() => setShowNewPassword(!showNewPassword)}>
                      {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                    </PasswordToggle>
                  </InputGroup>
                </FormGroup>

                <Button type="submit" disabled={!isResetFormValid}>Reset Password</Button>
                <BackToLoginLink onClick={() => setShowForgotPassword(false)}>
                  Back to Login
                </BackToLoginLink>
              </form>
            </>
          )}
        </LoginFormContainer>

        <FooterText>Copyright ©YOX9.com 2023.</FooterText>
      </LoginFormWrapper>
    </LoginPageContainer>
  );
};

// Styled Components
const LoginPageContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background: #ffffff;
  justify-content: center;
  align-items: flex-start;
  padding-top: 4rem;
`;

const LoginFormWrapper = styled.div`
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LoginFormContainer = styled.div`
  width: 100%;
  max-width: 400px;
  padding: 2rem 1.5rem 1.5rem;
  text-align: center;
`;

const Logo = styled.div`
  margin-bottom: 2rem;
`;

const BrandHeading = styled.h1`
  font-size: 6.2rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
`;

const BrandMain = styled.span`
  color:rgb(138, 183, 166);;
  margin-right: 0.2rem;
`;

const BrandAccent = styled.span`
  color:rgb(138, 183, 166);;
`;

const FormTitle = styled.h2`
  color: #1b5fc5;
  margin-bottom: 2rem;
  font-weight: 600;
  font-size: 1.2rem;
`;

const ErrorMessage = styled.p`
  color: #dc2626;
  text-align: center;
  margin-bottom: 1rem;
  font-size: 0.9rem;
`;

const FormGroup = styled.div`
  margin-bottom: 1rem;
`;

const InputGroup = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #d0d0d0;
  background: white;
  position: relative;
  min-height: 48px;
`;

const IconWrapper = styled.div`
  width: 40px;
  height: 100%;
  background: #ffffff;
  color: #757575;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 14px;
  border-right: 1px solid #e0e0e0;
`;

const Input = styled.input`
  flex: 1;
  padding: 12px 15px;
  border: none;
  background: transparent;
  outline: none;
  font-size: 14px;
  color: #333;

  &::placeholder {
    color: #999;
  }
`;

const Button = styled.button`
  width: 100%;
  padding: 12px;
  background: rgb(138, 183, 166);
  color: white;
  border: none;
  cursor: pointer;
  font-size: 14px;
  margin-top: 1rem;
  margin-bottom: 1.5rem;
  text-transform: uppercase;
  font-weight: 600;

  &:hover:not(:disabled) {
    background: #d8004b;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const ForgotPasswordLink = styled.p`
  text-align: right;
  cursor: pointer;
  color: #666;
  font-size: 12px;
  margin: 0.5rem 0;
`;

const BackToLoginLink = styled.p`
  text-align: center;
  cursor: pointer;
  color: #666;
  margin-top: 1rem;
  font-size: 12px;
`;

const SuccessMessage = styled.p`
  color: #22c55e;
  text-align: center;
  margin-bottom: 1rem;
`;

const PasswordToggle = styled.div`
  position: absolute;
  right: 15px;
  color: #666;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #333;
  }
`;

const RememberRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  margin-top: 0.25rem;
`;

const RememberCheckbox = styled.input`
  width: 14px;
  height: 14px;
  cursor: pointer;
`;

const RememberLabel = styled.label`
  font-size: 12px;
  color: #333;
  cursor: pointer;
`;

const FooterText = styled.p`
  margin-top: 3rem;
  font-size: 12px;
  color: #9e9e9e;
  text-align: center;
`;

export default LoginPage;






// import React, { useState,useEffect } from 'react'; // Ensure useState is imported
// import { useNavigate } from 'react-router-dom';
// import styled from 'styled-components';
// import { FaLock, FaUser, FaEye, FaEyeSlash } from 'react-icons/fa';
// import { Link } from 'react-router-dom';
// import axios from 'axios'

// const LoginPage = () => {
//   const navigate = useNavigate();
//   const [error, setError] = useState('');
 
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [isFormValid, setIsFormValid] = useState(false);
//   const [showForgotPassword, setShowForgotPassword] = useState(false);
//   const [newPassword, setNewPassword] = useState('');
//   const [resetMessage, setResetMessage] = useState('');
//   const [isResetFormValid, setIsResetFormValid] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [showNewPassword, setShowNewPassword] = useState(false);
//   const [username, setUsername] = useState('');
//   const [userNo, setUserNo] = useState('');
  
//   useEffect(() => {
//     const storedUsername = localStorage.getItem('UserNo'); // Retrieve from LocalStorage
//     if (storedUsername) {
//       setUsername(storedUsername);
//     }
//   }, []);
//   console.log("USErnameNo",username)

//   useEffect(() => {
//     const fetchUserNo = async () => {
//       try {
//         const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/userLoginUserNo/${username}`);
//         const data = await response.json();

//         if (data.success) {
//           setUserNo(data.userNo);
//         } else {
//           console.error('User not found');
//         }
//       } catch (error) {
//         console.error('Error fetching userNo:', error);
//       }
//     };

//     if (username) {
//       fetchUserNo();
//     }
//   }, [username]);
  
//   const validateForm = () => {
//     const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
//     const isPasswordValid = password.length >= 6;
//     setIsFormValid(isEmailValid && isPasswordValid);
//   };

//   const validateResetForm = () => {
//     const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
//     const isNewPasswordValid = newPassword.length >= 6;
//     setIsResetFormValid(isEmailValid && isNewPasswordValid);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     console.log("okkkk")
//     try {
//       const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/login`, (
//         // method: 'POST',
//         // headers: { 'Content-Type': 'application/json' },
//          {userNo:userNo , password:password} )
//       );

//       console.log(response);
//       if (response.status == 200) {
//         localStorage.setItem('user', JSON.stringify(response.data.user));
//         localStorage.setItem('wallet', JSON.stringify(response.data.wallet));
//         localStorage.setItem('history', JSON.stringify(response.data.history));
        
//         // Check if it's first-time login
//         if (response.data.isFirstLogin) {
//           // Redirect to change password page
//           navigate('/change-password');
//         } else {
//           // Normal login flow
//           navigate('/');
//           window.location.reload();
//         }
//       } else {
//         setError(response.message || 'Login failed. Please try again.');
//       }
//     } catch (error) {
//       setError(error.response.data.message);
//       console.log(error);
//     }
//   };

//   const handleForgotPassword = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/forgot-password`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ email, newPassword }),
//       });

//       const data = await response.json();
//       if (response.ok) {
//         setResetMessage('Password reset successful! You can now log in with the new password.');
//         setShowForgotPassword(false);
//         setNewPassword('');
//       } else {
//         setResetMessage(data.message || 'Password reset failed. Try again.');
//       }
//     } catch (error) {
//       setResetMessage('Error connecting to server. Try again later.');
//     }
//   };

//   return (
//     <LoginPageContainer>
//       <LoginFormWrapper>
//         <LoginFormContainer>
//           <Logo>
//             <BrandHeading>
//               <BrandMain>YOX</BrandMain>
//               <BrandAccent>9</BrandAccent>
//             </BrandHeading>
//           </Logo>

//           {!showForgotPassword ? (
//             <>
//               <FormTitle>Sign in</FormTitle>
//               {error && <ErrorMessage>{error}</ErrorMessage>}
//               <form onSubmit={handleSubmit}>
//                 <FormGroup>
//                   <InputGroup>
//                     <IconWrapper>
//                       C
//                     </IconWrapper>
//                     <Input
//                       type="text"
//                       placeholder="Client Code*"
//                       value={userNo}
//                       onChange={(e) => setUserNo(e.target.value)}
//                       required
//                     />
//                   </InputGroup>
//                 </FormGroup>

//                 <FormGroup>
//                   <InputGroup>
//                     <IconWrapper>
//                       <FaLock />
//                     </IconWrapper>
//                     <Input
//                       type={showPassword ? "text" : "password"}
//                       placeholder="Password*"
//                       value={password}
//                       onChange={(e) => {
//                         setPassword(e.target.value);
//                       }}
//                       required
//                     />
//                     <PasswordToggle onClick={() => setShowPassword(!showPassword)}>
//                       {showPassword ? <FaEyeSlash /> : <FaEye />}
//                     </PasswordToggle>
//                   </InputGroup>
//                 </FormGroup>

//                 <RememberRow>
//                   <RememberCheckbox type="checkbox" id="rememberMe" />
//                   <RememberLabel htmlFor="rememberMe">Remember me</RememberLabel>
//                 </RememberRow>

//                 <Button type="submit">
//                   SIGN IN
//                 </Button>
//               </form>
//             </>
//           ) : (
//             <>
//               <FormTitle>Reset Password</FormTitle>
//               {resetMessage && <SuccessMessage>{resetMessage}</SuccessMessage>}
//               <form onSubmit={handleForgotPassword}>
//                 <FormGroup>
//                   <InputGroup>
//                     <IconWrapper>
//                       <FaUser />
//                     </IconWrapper>
//                     <Input
//                       type="email"
//                       placeholder="Your Email"
//                       value={email}
//                       onChange={(e) => {
//                         setEmail(e.target.value);
//                         validateResetForm();
//                       }}
//                       required
//                     />
//                   </InputGroup>
//                 </FormGroup>

//                 <FormGroup>
//                   <InputGroup>
//                     <IconWrapper>
//                       <FaLock />
//                     </IconWrapper>
//                     <Input
//                       type={showNewPassword ? "text" : "password"}
//                       placeholder="New Password"
//                       value={newPassword}
//                       onChange={(e) => {
//                         setNewPassword(e.target.value);
//                         validateResetForm();
//                       }}
//                       required
//                     />
//                     <PasswordToggle onClick={() => setShowNewPassword(!showNewPassword)}>
//                       {showNewPassword ? <FaEyeSlash /> : <FaEye />}
//                     </PasswordToggle>
//                   </InputGroup>
//                 </FormGroup>

//                 <Button type="submit" disabled={!isResetFormValid}>Reset Password</Button>
//                 <BackToLoginLink onClick={() => setShowForgotPassword(false)}>
//                   Back to Login
//                 </BackToLoginLink>
//               </form>
//             </>
//           )}
//         </LoginFormContainer>

//         <FooterText>Copyright ©YOX9.com 2023.</FooterText>
//       </LoginFormWrapper>
//     </LoginPageContainer>
//   );
// };

// // Styled Components
// const LoginPageContainer = styled.div`
//   display: flex;
//   min-height: 100vh;
//   background: #ffffff;
//   justify-content: center;
//   align-items: flex-start;
//   padding-top: 4rem;
// `;

// const LoginFormWrapper = styled.div`
//   width: 100%;
//   max-width: 400px;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
// `;

// const LoginFormContainer = styled.div`
//   width: 100%;
//   max-width: 400px;
//   padding: 2rem 1.5rem 1.5rem;
//   text-align: center;
// `;

// const Logo = styled.div`
//   margin-bottom: 2rem;
// `;

// const BrandHeading = styled.h1`
//   font-size: 6.2rem;
//   font-weight: 700;
//   margin-bottom: 1.5rem;
// `;

// const BrandMain = styled.span`
//   color:rgb(138, 183, 166);;
//   margin-right: 0.2rem;
// `;

// const BrandAccent = styled.span`
//   color:rgb(138, 183, 166);;
// `;

// const FormTitle = styled.h2`
//   color: #1b5fc5;
//   margin-bottom: 2rem;
//   font-weight: 600;
//   font-size: 1.2rem;
// `;

// const ErrorMessage = styled.p`
//   color: #dc2626;
//   text-align: center;
//   margin-bottom: 1rem;
//   font-size: 0.9rem;
// `;

// const FormGroup = styled.div`
//   margin-bottom: 1rem;
// `;

// const InputGroup = styled.div`
//   display: flex;
//   align-items: center;
//   border: 1px solid #d0d0d0;
//   background: white;
//   position: relative;
//   min-height: 48px;
// `;

// const IconWrapper = styled.div`
//   width: 40px;
//   height: 100%;
//   background: #ffffff;
//   color: #757575;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   font-weight: 500;
//   font-size: 14px;
//   border-right: 1px solid #e0e0e0;
// `;

// const Input = styled.input`
//   flex: 1;
//   padding: 12px 15px;
//   border: none;
//   background: transparent;
//   outline: none;
//   font-size: 14px;
//   color: #333;

//   &::placeholder {
//     color: #999;
//   }
// `;

// const Button = styled.button`
//   width: 100%;
//   padding: 12px;
//   background: rgb(138, 183, 166);
//   color: white;
//   border: none;
//   cursor: pointer;
//   font-size: 14px;
//   margin-top: 1rem;
//   margin-bottom: 1.5rem;
//   text-transform: uppercase;
//   font-weight: 600;

//   &:hover:not(:disabled) {
//     background: #d8004b;
//   }

//   &:disabled {
//     opacity: 0.6;
//     cursor: not-allowed;
//   }
// `;

// const ForgotPasswordLink = styled.p`
//   text-align: right;
//   cursor: pointer;
//   color: #666;
//   font-size: 12px;
//   margin: 0.5rem 0;
// `;

// const BackToLoginLink = styled.p`
//   text-align: center;
//   cursor: pointer;
//   color: #666;
//   margin-top: 1rem;
//   font-size: 12px;
// `;

// const SuccessMessage = styled.p`
//   color: #22c55e;
//   text-align: center;
//   margin-bottom: 1rem;
// `;

// const PasswordToggle = styled.div`
//   position: absolute;
//   right: 15px;
//   color: #666;
//   cursor: pointer;
//   display: flex;
//   align-items: center;
//   justify-content: center;

//   &:hover {
//     color: #333;
//   }
// `;

// const RememberRow = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: flex-start;
//   gap: 8px;
//   margin-top: 0.25rem;
// `;

// const RememberCheckbox = styled.input`
//   width: 14px;
//   height: 14px;
//   cursor: pointer;
// `;

// const RememberLabel = styled.label`
//   font-size: 12px;
//   color: #333;
//   cursor: pointer;
// `;

// const FooterText = styled.p`
//   margin-top: 3rem;
//   font-size: 12px;
//   color: #9e9e9e;
//   text-align: center;
// `;

// export default LoginPage;
